import { sessionReducer } from '@hotelescalle1/heyrev-core-kit/auth-api'
import { combineReducers } from '@reduxjs/toolkit'

export const rootReducer = combineReducers({
  session: sessionReducer
})

export default rootReducer
